<script setup lang="ts">
defineOptions({
  name: 'SimpleLegend',
})

withDefaults(defineProps<{
  items?: SimpleLegendItem[]
}>(), {
  items: () => [],
})

interface SimpleLegendItem {
  name: string
  disabled?: boolean
  color?: string
}
</script>

<template>
  <div class="flex flex-wrap gap-x-4 gap-y-2">
    <ChartLegendItem
      v-for="{ name, disabled, color } in items"
      :key="name"
      :data="{
        name,
        color,
        data: [1],
      }"
      :disabled="disabled"
    />
  </div>
</template>
